import BemIt, { addClass } from "@gtechdoodler/bem-it";
import useViewport from "../../../hooks/useViewport";
import { PageSectionProps } from "./PageSection.types";
import { StyledPage } from "./PageSection.styles";

const Page: React.FC<PageSectionProps> = ({ className, ...props }) => {
	const block = new BemIt("PageSection");
	const vp = useViewport();

	return (
		<StyledPage
			className={addClass(className).after(block)}
			viewport={vp}
			suppressHydrationWarning
			{...props}
		>
			{props.children}
		</StyledPage>
	);
};

export default Page;
